import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import VerifyEmailBanner from "@/components/VerifyEmailBanner";

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <VerifyEmailBanner />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
